// extracted by mini-css-extract-plugin
export default {"button":"lPIOZ","disabled":"Q6meC","selected":"lr4Bz","size_m":"BXirH","icon":"zOdHt","size_l":"G2qrV"};